// extracted by mini-css-extract-plugin
export var deleteModal = "_fv-0";